import { OnboardingBaseTask } from '@weave/schema-gen-ts/dist/shared/call-intelligence/plg/onboarding.pb';
import { useTranslation } from '@frontend/i18n';
import { type TaskContentProps } from '@frontend/product-onboarding';
import { useBaseOnboardingProgress } from '../hooks/use-base-onboarding-progress';
import { useTaskActions } from '../task-actions/use-task-actions';
import { OnboardingTaskContentView } from './onboarding-task-content-view';

export function BaseProductTaskContent(props: TaskContentProps) {
  const { t } = useTranslation('call-intel-onboarding');

  const actions = useTaskActions({ onClose: props.onClose });
  const { completedGroups } = useBaseOnboardingProgress();

  return (
    <OnboardingTaskContentView<OnboardingBaseTask>
      {...props}
      title={t('Get Started with Summaries & Transcripts')}
      completedGroups={completedGroups}
      actions={actions}
    />
  );
}
